import type { ReactNode } from "react";

interface StickyFooterLayoutProps {
  /** The routed page content. */
  children: ReactNode;
  /** Footer chrome pinned to the bottom (usually a `PageFooter`). Omit to hide. */
  footer?: ReactNode | undefined;
}

/**
 * App-shell layout that pins `footer` to the bottom of the viewport even when
 * the page content is short — the content area grows to fill, so the footer
 * never floats mid-screen. App shells wrap their routed content in this.
 */
export function StickyFooterLayout({
  children,
  footer,
}: StickyFooterLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <div className="flex-1">{children}</div>
      {footer}
    </div>
  );
}
